module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("My Dear Boys.")]), _vm._v("—Those of you who were interested\nin the first story of this series, telling\nhow Larry Dexter rose from a copy boy to become\na reporter, may desire to follow his further\nadventures as a newspaper worker. Many of\nthe occurrences told of in this volume are actual\nones. In some I participated personally. In others\nnewspaper friends of mine were concerned,\nthough I have made some slight changes from\nwhat actually happened.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_vi",
      "title": "vi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The tracing of the blue-handed man, who blew\nopen the safe by means of nitro-glycerine, is an\nactual fact, having taken place in the city where\nI live. He was arrested afterwards because a\ndetective observed the stains left by the acid on\nhis fingers. The riot in Chinatown is similar to\nseveral that have occurred there, and kidnappings,\nsuch as befell Jimmy, are common enough\nin New York. There are few reporters, especially\non the large papers, who have not gone\nthrough as thrilling incidents as those which happened\nto Larry, for, as I can vouch from many\nyears’ experience, a newspaper man’s life is anything\nbut a quiet and uneventful one.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    staticClass: "center2"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('span', {
    staticClass: "jr1"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Howard R. Garis")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre9"
  }, [_vm._v("July 1, 1907.")])]), _vm._v(" "), _c('div', {
    staticClass: "pg-boilerplate",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0